import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminBoardService from "../../service/AdminBoardService";
import Button from "../atom/Button";

const AdminVocLoginPage = () => {
  const [AdminPassword, setAdiminPassword] = useState<string>("");
  const [flag, setFlag] = useState<boolean>(false);

  const page = 0;
  const size = 15;
  const accept: string = "4";
  const navigate = useNavigate();

  const handleLoginAdminChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value);
    setAdiminPassword(e.target.value);
  };

  const activeEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLoginAdiminSubmit();
    }
  };

  useEffect(() => {
    if (!!flag) {
      moveBoardPage();
    }
  }, [flag]);

  const handleLoginAdiminSubmit = async () => {
    const responseAssign = await AdminBoardService.getAssignVoc();
    const dataList = await responseAssign.data; //조치담당자 호출

    localStorage.setItem("assingPersonList", JSON.stringify(dataList));

    const response = await AdminBoardService.getVocBoardList(page, size, AdminPassword, accept);
    // console.log(response);
    if (response.status === "success") {
      sessionStorage.setItem("isAdmin", "true");
      sessionStorage.setItem("pw", `${AdminPassword}`);
      setFlag(true);
    } else {
      alert("로그인 실패");
    }
  };

  const moveBoardPage = () => {
    navigate("/AdminVocBoard");
  };

  return (
    <div className="loginPage">
      <div className="loginBox">
        <div className="inputBox">
          <p>관리자 인증</p>
          <div className="inputBoxStyle">
            <form>
              <div>
                <p>PW</p>
                <input
                  onChange={handleLoginAdminChange}
                  onKeyDown={(e) => activeEnter(e)}
                  type="password"
                  placeholder="패스워드를 입력해주세요."
                />
                <input type="text" hidden />
              </div>
              <div className="loginBtn">
                <Button
                  text={"로그인"}
                  backgroundColor={"#388fc0"}
                  fontColor={"white"}
                  borderRadius={"5px"}
                  width={"361px"}
                  type={"submit"}
                  onClick={handleLoginAdiminSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminVocLoginPage;
